module.exports = __webpack_public_path__ + "img/alignCenter.37bf1f03.svg";